import type { ChecklistItem } from "@/lib/chat-types";

const statusCfg = {
  pass:    { color: "text-green-400", bg: "bg-green-500/10" },
  fail:    { color: "text-red-400",   bg: "bg-red-500/10" },
  warning: { color: "text-amber-400", bg: "bg-amber-500/10" },
} as const;

function StatusIcon({ status }: { status: ChecklistItem["status"] }) {
  if (status === "pass")
    return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-green-400 shrink-0"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" /></svg>;
  if (status === "fail")
    return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-red-400 shrink-0"><circle cx="12" cy="12" r="10" /><line x1="15" y1="9" x2="9" y2="15" /><line x1="9" y1="9" x2="15" y2="15" /></svg>;
  return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-amber-400 shrink-0"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" /><line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" /></svg>;
}

export function ChecklistBlock({ checklist }: { checklist: ChecklistItem[] }) {
  return (
    <div className="flex flex-col gap-1 my-2">
      {checklist.map((item, i) => {
        const c = statusCfg[item.status];
        return (
          <div key={i} className="flex items-center gap-2.5 px-3 py-2 rounded-lg bg-[var(--color-surface)] border border-[var(--color-border)]">
            <StatusIcon status={item.status} />
            <span className="flex-1 text-[13px] font-medium text-[var(--color-fg)]">{item.label}</span>
            {item.detail && (
              <span className="text-[11px] text-[var(--color-fg-tertiary)] shrink-0 hidden sm:inline" style={{ fontFamily: "var(--font-mono)" }}>{item.detail}</span>
            )}
            <span
              className={`px-1.5 py-0.5 rounded-full text-[9px] font-bold uppercase tracking-wide ${c.bg} ${c.color}`}
              style={{ fontFamily: "var(--font-mono)" }}
            >
              {item.status}
            </span>
          </div>
        );
      })}
    </div>
  );
}
